import React from "react";

export function HeadCountIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_14818_117404)">
        <path d="M13.2727 10.8182C12.4 10.8182 11.04 11.0655 10 11.5455C8.96 11.0582 7.6 10.8182 6.72727 10.8182C5.14909 10.8182 2 11.6036 2 13.1818V15.1818H18V13.1818C18 11.6036 14.8509 10.8182 13.2727 10.8182ZM10.3636 14.0909H3.09091V13.1818C3.09091 12.7891 4.95273 11.9091 6.72727 11.9091C8.50182 11.9091 10.3636 12.7891 10.3636 13.1818V14.0909ZM16.9091 14.0909H11.4545V13.1818C11.4545 12.8473 11.3091 12.5564 11.0764 12.2945C11.7164 12.0764 12.5018 11.9091 13.2727 11.9091C15.0473 11.9091 16.9091 12.7891 16.9091 13.1818V14.0909ZM6.72727 10.0909C8.13091 10.0909 9.27273 8.94909 9.27273 7.54545C9.27273 6.14182 8.13091 5 6.72727 5C5.32364 5 4.18182 6.14182 4.18182 7.54545C4.18182 8.94909 5.32364 10.0909 6.72727 10.0909ZM6.72727 6.09091C7.52727 6.09091 8.18182 6.74545 8.18182 7.54545C8.18182 8.34545 7.52727 9 6.72727 9C5.92727 9 5.27273 8.34545 5.27273 7.54545C5.27273 6.74545 5.92727 6.09091 6.72727 6.09091ZM13.2727 10.0909C14.6764 10.0909 15.8182 8.94909 15.8182 7.54545C15.8182 6.14182 14.6764 5 13.2727 5C11.8691 5 10.7273 6.14182 10.7273 7.54545C10.7273 8.94909 11.8691 10.0909 13.2727 10.0909ZM13.2727 6.09091C14.0727 6.09091 14.7273 6.74545 14.7273 7.54545C14.7273 8.34545 14.0727 9 13.2727 9C12.4727 9 11.8182 8.34545 11.8182 7.54545C11.8182 6.74545 12.4727 6.09091 13.2727 6.09091Z" />
      </g>
      <defs>
        <clipPath id="clip0_14818_117404">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
